import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: 'app-html-editor-input-ctrl',
  templateUrl: './html-editor-input.component.html',
  styleUrls: ['./html-editor-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: HtmlEditorInputComponent,
    multi: true
  }]
})
export class HtmlEditorInputComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
  @Input() extendedVersion = false;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {uppercase:false, fxFill:false,rows:5};

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
  }

  onChange(value: string) {
    if (this.settings.uppercase) {
      value = value.toUpperCase();
    }

    this.control.setValue(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
